import React from "react";
import Comment from "./../../../svgs/Comment";
import { useTranslation } from "react-i18next";

const CommentDetails = ({ eventDetails }) => {
    const { t } = useTranslation();

    let label =
        eventDetails.postType % 2 === 1
            ? `${t("dhb.live.start_of_period")} ${
                  Math.floor((eventDetails.postType - 1) / 2) + 1
              }. ${eventDetails.periodName}`
            : `${t("dhb.live.end_of_period")} ${
                  Math.floor((eventDetails.postType - 1) / 2) + 1
              }. ${eventDetails.periodName}`;

    if (eventDetails.postType === 17) {
        label = t("comment");
    }
    return (
        <>
            <div
                style={{
                    width: "10%",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Comment fill={"#000"} />
            </div>
            <div
                style={{
                    width: "35%",
                    borderRight: "none",
                }}
            >
                {label}
            </div>
            <div
                style={{
                    width: "15%",
                    height: "18px",
                }}
            ></div>
        </>
    );
};

export default CommentDetails;
